import { render } from "./DriverFeedback.vue?vue&type=template&id=1fe91675&scoped=true&ts=true"
import script from "./DriverFeedback.vue?vue&type=script&lang=ts"
export * from "./DriverFeedback.vue?vue&type=script&lang=ts"

import "./DriverFeedback.vue?vue&type=style&index=0&id=1fe91675&scoped=true&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe91675"]])

export default __exports__